import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
};

export default function RHFTextField({ name, isNumber, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          onChange={(event) => {
            if (isNumber) {
              field.onChange(event.target.value.replace(/[^0-9.]/g, ''));
            } else {
              field.onChange(event.target.value);
            }
          }}
          fullWidth
          error={!!error}
          helperText={error?.message}
          {...other}
          sx={{
            '& .MuiInputBase-input.Mui-disabled': {
              backgroundColor: other.addDisabledColor ? '#7a7a7a0d' : '#fff',
            },
          }}
        />
      )}
    />
  );
}
